<template>
  <div class="CenterButton"> 
    <div class="CenterButton__background" 
      @touchstart="(event) => warn(event, 'start')"
      @touchmove="(event) => warn(event, 'move')"
      @touchend="(event) => warn(event, 'end')"/>
    <Description ref="description" indice="recenter"/>
    <div ref="block" class="Bottom">
      <div 
        ref="button" 
        class="Button" 
        @touchstart="(event) => onTouch(event)">
        <div>Continue</div>
      </div> 
    </div>
  </div> 
</template>

<script>

import gsap from "gsap"
import Description from "./Description.vue"

export default {
  name: 'CenterButton',
  components: { Description },
  data: ()=>({
    moved: false,
    odp: null,
    rotate: true
  }),
  mounted() {
    gsap.from([ this.$refs.description.$el, this.$refs.button ], { 
      duration: .5, 
      opacity: 0, 
      y: 200, 
      delay: .25, 
      stagger: .1,
      ease: 'back.out'
    })
  },
  methods:{
    warn(ev, type) {

      // console.log(type, this.moved);
      // console.log('');

      if(type == 'end'){
        gsap.delayedCall(.25, ()=>{ 
          this.moved = false
          this.rotate = true
        })
        this.$store.commit('app/UPDATE_ROTATION', 0)
      }
      else if (ev.touches.length === 1 && this.rotate) { 
        if(type ==  'start') {
          this.odp = [ ev.targetTouches[0].clientX, ev.targetTouches[0].clientY ]
        }
        else {
          this.moved = true
          const pos = this.getDistance(ev.targetTouches[0].clientX, ev.targetTouches[0].clientY, this.odp[0], this.odp[1]) 

          const way = ev.targetTouches[0].clientX < this.odp[0] ? -pos : pos

          this.$store.commit('app/UPDATE_ROTATION', way)
          this.odp = [ ev.targetTouches[0].clientX, ev.targetTouches[0].clientY ]  
        }
      } 
      else if (ev.touches.length === 2) { 
        if(type ==  'start') {
          this.rotate = false
          this.str = this.getDistance(ev.targetTouches[0].clientX, ev.targetTouches[0].clientY, ev.targetTouches[1].clientX, ev.targetTouches[1].clientY)
        }
        else {
          this.moved = true
          const dist = this.getDistance(ev.targetTouches[0].clientX, ev.targetTouches[0].clientY, ev.targetTouches[1].clientX, ev.targetTouches[1].clientY)
          const sc = Math.round(dist-this.str)
          this.$store.commit('app/UPDATE_SCALE', sc)
        }
      } 
    }, 
    getDistance(x1, y1, x2, y2){
      let y = x2 - x1
      let x = y2 - y1  
      return Math.sqrt(x * x + y * y)
    },
    onTouch(ev) {
      this.$router.push({ params: { section: 'weave' } })
    },
  }
}

</script>

<style lang="stylus">
@import '~@/config/Settings'

.CenterButton
  position absolute
  color purple
  width 100%
  height 100%
  display flex
  flex-direction column
  align-items center
  justify-content flex-end
  z-index 600

  &__background 
    width 100%
    height 68%
    background transparent

</style>


